/* eslint-disable react/prop-types */
import React, { useCallback, useState } from 'react';
import ReactNumberFormat from 'react-number-format';

import { configTonelada } from '../../helpers/form';
import { BaseTextField, TextFieldOutlined } from './styles';

const NumberFormat = ({ id, label, required, width, ...props }) => {
  const [isFocused, setIsFocused] = useState(false);
  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);
  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
  }, []);
  return (
    <BaseTextField width={width}>
      <TextFieldOutlined
        {...props}
        hasPlaceholder={!!label}
        isFocused={isFocused}
        data-testid="textfield-outlined-id"
      >
        <ReactNumberFormat
          id={id}
          type="text"
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          placeholder={' '}
          {...configTonelada}
          {...props}
        />
        <label htmlFor={id} id="input-label-id" data-testid="input-label-id">
          {label}
          {required && '*'}
        </label>
        <fieldset aria-hidden="true">
          <legend>
            <span>
              {label}
              {required && '*'}
            </span>
          </legend>
        </fieldset>
      </TextFieldOutlined>
    </BaseTextField>
  );
};

export default NumberFormat;
